import axios from 'axios'

// https://portal.azure.com/#blade/Microsoft_AAD_RegisteredApps/ApplicationsListBlade
// https://docs.microsoft.com/en-gb/azure/active-directory/develop/howto-configure-publisher-domain

export default {
    namespaced: true,
    state: {
        config: {
            auth: {
                authority: null,
                clientId: null,
            },
            system: {
                iframeHashTimeout: 10000,
            },
            cache: {
                cacheLocation: 'localStorage',
            }
        },
        instance: null,
        scopes: ['user.read', 'user.readbasic.all', 'directory.read.all', 'openid', 'profile'],
        accounts: [],
        account: null,
    },
    mutations: {
        SET_AUTHORITY(state, payload) {
            state.config.auth.authority = `https://login.microsoftonline.com/${payload}`;
        },
        SET_CLIENTID(state, payload) {
            state.config.auth.clientId = payload;
        },
        SET_INSTANCE(state, payload) {
            state.instance = payload;
        },
        SET_INSTANCE(state, payload) {
            state.instance = payload;
        },
        SET_ACCOUNTS(state, payload) {
            state.accounts = payload;
        },
        SET_ACCOUNT(state, payload) {
            state.account = payload;
        },
        CLEAR_AUTH(state) {
            state.accounts = [];
            state.account = null;
            state.accessToken = null;
        }
    },
    actions: {
        SetAuthority({ commit }) {
            return new Promise((resolve, reject) => {
                axios.get(`${process.env.BASE_URL}api/auth/tenantid`)
                    .then(response => {
                        if (response.status == 200) {
                            commit('SET_AUTHORITY', response.data);
                            resolve();
                        }
                    }).catch(error => reject(`SetAuthority: ${error.message}`));
            });
        },
        SetClientID({ commit }) {
            return new Promise((resolve, reject) => {
                axios.get(`${process.env.BASE_URL}api/auth/clientid`)
                    .then(response => {
                        if (response.status == 200) {
                            commit('SET_CLIENTID', response.data);
                            resolve();
                        }
                    }).catch(error => reject(`SetClientID: ${error.message}`));
            });
        },
        SetInstance({ commit }, obj) {
            commit('SET_INSTANCE', obj);
        },
        SetAccounts({ commit }, obj) {
            commit('SET_ACCOUNTS', obj);
        },
        SetAccount({ commit }, obj) {
            commit('SET_ACCOUNT', obj);
        },
        ClearAuth({ commit }) {
            commit('CLEAR_AUTH');
        },
    },
    getters: {
        Config(state) {
            return state.config;
        },
        Instance(state) {
            return state.instance;
        },
        Scopes(state) {
            return state.scopes;
        },
        Accounts(state) {
            return state.accounts;
        },
        Account(state) {
            return state.account;
        },
    },
}
